import { useState, useEffect, useContext, useCallback } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  TextField,
} from "@material-ui/core";
import {
  ArrowUpward,
  ArrowDownward,
  Search,
  Clear,
  Refresh,
  Star,
  AttachFile,
} from "@material-ui/icons";
import { useHistory, Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { Search_Panel } from "./../components/Work_SearchPanel/index";
import { workAPI } from "./../services/WorkService";
import Swal from "sweetalert2";
import moment from "moment";
import { AppContext } from "./../contexts/appContext";
import { NoIpadDevice } from "../utils/config";

const Work = (props) => {
  let history = useHistory();
  const token = localStorage.getItem("Token");
  const LocalType = localStorage.getItem("Type");
  const LocalRowPerPagee = localStorage.getItem("RowPerPage");
  const LocalstartDate = localStorage.getItem("startDate");
  const LocalendDate = localStorage.getItem("endDate");
  const LocalStatus = localStorage.getItem("Status");
  const { user, socket } = useContext(AppContext);
  const [startDate, setStartDate] = useState(
    LocalstartDate ? LocalstartDate : moment().startOf("month").toDate()
  );
  const [endDate, setEndDate] = useState(
    LocalendDate ? LocalendDate : moment(startDate).endOf("month").toDate()
  );
  const [type, setType] = useState([]);
  const [SelectType, setSelectType] = useState(LocalType ? LocalType : null);
  const [data, setData] = useState([]);
  const [force, setForce] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(
    LocalRowPerPagee ? parseInt(LocalRowPerPagee) : 10
  );
  const [filterData, setFilterData] = useState(
    LocalStatus ? LocalStatus : null
  );
  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [socketUpdate, setSocketUpdate] = useState([]);

  useEffect(() => {
    document.title = "Com7 Merchandise - หน้าสำหรับการทำงาน";
    if (user?.view_work) {
      setLoading(true);
      workAPI
        .GetWork(token, { date_start: startDate, date_end: endDate })
        .then((res) => {
          if (res.status == 200) {
            if (Array.isArray(res.message)) {
              setData(res.message);
              let type_fromdata = res.message.reduce((prev, curr) => {
                let find_dup_type = prev.find((res) => res.value == curr.type);
                if (!find_dup_type) {
                  prev.push({ value: curr.type, label: curr.type });
                }
                return prev;
              }, []);
              setType(type_fromdata);
            } else {
              Swal.fire({
                icon: "error",
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">API DATA is not Array</span>`,
                backdrop: "transparent",
                background: "rgba(0,0,0,.75)",
                customClass: {
                  icon: "switch",
                },
                width: "28rem",
                timer: 5000,
              }).then(() => {
                setForce((old) => old + 1);
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">Something Wrong!!!</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            }).then(() => {
              setForce((old) => old + 1);
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          }).then(() => {
            setForce((old) => old + 1);
          });
        })
        .finally(() => {
          setLoading(false);
        });

      return () => {
        setLoading(false);
        setData([]);
        setType([]);
      };
    }
  }, [user, force, startDate, endDate]);

  useEffect(() => {
    if (filterData) {
      localStorage.setItem("Status", filterData);
    }
  }, [filterData]);

  useEffect(() => {
    if (user?.get_work) {
      socket.emit("join", { room: user.username });
      socket.on("UpdateWork", ({ message, type }) => {
        if (type == "Delete") {
          setData((old) => {
            return old.filter((res) => res._id != message._id);
          });
        } else {
          setSocketUpdate((old) => [...old, message._id]);
          setData((old) => {
            let findIndex = old.findIndex((res) => res._id == message._id);
            if (findIndex != -1) {
              let dataZ = [...old];
              dataZ[findIndex] = message;
              return dataZ;
            } else {
              return [...old, message];
            }
          });
        }
      });
    }
    return () => {
      socket.off("UpdateWork", ({ message }) => {
        let findIndex = data.findIndex((res) => res._id == message._id);
        if (findIndex != -1) {
          let dataZ = [...data];
          dataZ[findIndex] = message;
          setData(dataZ);
        } else {
          setData((old) => [...old, message]);
        }
      });
    };
  }, [user]);

  useEffect(() => {
    if (socketUpdate.length > 0) {
      let timeout = setTimeout(() => {
        let socketUpdateZ = socketUpdate.filter((res, i) => i != 0);
        setSocketUpdate(socketUpdateZ);
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [socketUpdate]);

  useEffect(() => {
    if (!SelectType) {
      localStorage.removeItem("Type");
    }
  }, [SelectType]);

  const statusChange = (status) => {
    switch (status) {
      case "New":
        return "New";
      case "Pending":
        return "On Process";
      case "Accept":
        return "Close";
      default:
        return status;
    }
  };

  const filterCondition = (res) => {
    let concat_string = `${res?.title}`.concat(
      res.fullname,
      statusChange(res.status),
      res.type,
      res.createdAt,
      res.fullname2,
      res.id_created,
      res.updatedAt
    );
    if (searchText != "" && SelectType)
      return (
        concat_string.toLowerCase().includes(searchText.toLowerCase()) &&
        res.type == SelectType
      );
    if (searchText != "" && !SelectType)
      return concat_string.toLowerCase().includes(searchText.toLowerCase());
    if (searchText == "" && SelectType) return res.type == SelectType;
    else return true;
  };

  let searchProps = {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    type,
    SelectType,
    setSelectType,
    setPage,
  };

  const caseWork = (params) => {
    switch (params) {
      case "New":
        return Number(1);
      case "Pending":
        return Number(2);
      case "Accept":
        return Number(3);
      case "Decline":
        return Number(4);
      default:
        return params;
    }
  };

  const sortData = () => {
    let compareFn = null;
    switch (sortBy) {
      case "createdAt":
        compareFn = (i, j) => {
          if (moment(i[sortBy]).valueOf() < moment(j[sortBy]).valueOf()) {
            return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
          } else {
            if (moment(i[sortBy]).valueOf() > moment(j[sortBy]).valueOf()) {
              return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0;
            } else {
              return 0;
            }
          }
        };
        break;
      case "updatedAt":
        compareFn = (i, j) => {
          if (moment(i[sortBy]).valueOf() < moment(j[sortBy]).valueOf()) {
            return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
          } else {
            if (moment(i[sortBy]).valueOf() > moment(j[sortBy]).valueOf()) {
              return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0;
            } else {
              return 0;
            }
          }
        };
        break;
      case "status":
        compareFn = (i, j) => {
          if (Number(caseWork(i[sortBy])) < Number(caseWork(j[sortBy]))) {
            return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
          } else {
            if (Number(caseWork(i[sortBy])) > Number(caseWork(j[sortBy]))) {
              return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0;
            } else {
              return 0;
            }
          }
        };
        break;
      default:
        compareFn = (i, j) => {
          if (i[sortBy] < j[sortBy]) {
            return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
          } else {
            if (i[sortBy] > j[sortBy]) {
              return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0;
            } else {
              return 0;
            }
          }
        };
    }
    return compareFn;
  };

  const deleteLastnameandEIEI = (name) => {
    // let cut = name.split(/นาย||นาง||นางสาว/i)
    let cut = name.split(" ");
    cut = cut[0];
    cut = cut.replace("นาย", "");
    cut = cut.replace("นางสาว", "");
    cut = cut.replace("นาง", "");
    cut = cut.trim();
    return cut;
  };

  const changeSortable = (name) => {
    if (name == sortBy) {
      if (sortOrder == "asc") {
        setSortOrder("desc");
      } else if (sortOrder == "desc") {
        setSortOrder("");
        setSortBy("");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
  };

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const Filter = data.filter(filterCondition);

  const filterStatusNoPin = (res) => {
    if (res.pin) {
      if (filterData) return filterData == res.status && !res.pin;
      else return !res.pin;
    } else {
      if (filterData) return filterData == res.status;
      else return true;
    }
  };

  const filterStatusPin = (res) => {
    if (res.pin) {
      if (filterData) return filterData == res.status && res.pin;
      else return res.pin;
    } else return false;
  };

  const DeleteWork = useCallback(
    ({ title, _id }) => {
      if (_id) {
        Swal.fire({
          title: "คุณแน่ใจ ?",
          text: `คุณต้องการลบ ${title}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#56A834",
          cancelButtonColor: "#d33",
          confirmButtonText: "แน่ใจ",
          cancelButtonText: "ยังก่อน",
        }).then((result) => {
          if (result.isConfirmed) {
            workAPI
              .DeleteWork(_id)
              .then((res) => {
                if (res.status == 200) {
                  Swal.fire({
                    icon: "success",
                    confirmButtonColor: "#6ab23a",
                    html: `<span class="colorWhite">ลบ ${title} เรียบร้อยแล้ว!</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switchZ",
                    },
                    width: "28rem",
                    timer: 3000,
                  }).then(() => {
                    socket.emit("UpdateWork", { _id: _id, type: "Delete" });
                    let newData = data.filter((rez) => rez._id != _id);
                    setData(newData);
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${res.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 5000,
                  });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${error.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 5000,
                });
              });
          }
        });
      } else {
        alert("Not ID");
      }
    },
    [data]
  );

  const updatePin = useCallback(
    (_id) => {
      if (_id) {
        workAPI.updatePin(_id).then((res) => {
          if (res.status == 200) {
            let index_data = data.findIndex(
              (rez) => rez._id == res.message.id_work
            );
            if (index_data >= 0) {
              let newData = [...data];
              newData[index_data].pin = res.pin;
              setData(newData);
            } else {
              setForce((old) => old + 1);
            }
          }
        });
      } else {
        alert("Not ID");
      }
    },
    [data]
  );

  const statusColorCheck = (status) => {
    if (status == "New")
      return {
        cursor: "default",
        border: "1px solid transparent ",
        borderRadius: "10px",
        textAlign: "center",
        color: "#fff",
        fontWeight: "bold",
        backgroundColor: "rgb(255, 105, 97)",
      };
    else if (status == "Pending")
      return {
        cursor: "default",
        border: "1px solid transparent ",
        borderRadius: "10px",
        textAlign: "center",
        color: "black",
        fontWeight: "bold",
        backgroundColor: "rgb(253, 253, 150)",
      };
    else if (status == "Accept")
      return {
        cursor: "default",
        border: "1px solid transparent ",
        borderRadius: "10px",
        textAlign: "center",
        color: "#fff",
        fontWeight: "bold",
        backgroundColor: "rgb(119, 221, 144)",
      };
    else if (status == "Decline")
      return {
        cursor: "default",
        border: "1px solid transparent ",
        borderRadius: "10px",
        textAlign: "center",
        color: "black",
        fontWeight: "bold",
        backgroundColor: "rgb(204, 204, 204)",
      };
    else return {};
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    localStorage.setItem(
      "RowPerPage",
      event.target.value != 0 ? parseInt(event.target.value) : 10
    );
    setrowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (Array.isArray(type) && type.length > 0) {
      let find = type.find((res) => res.value == SelectType);
      if (!find) {
        setSelectType(null);
      }
    }
  }, [type]);

  return (
    user && (
      <>
        {NoIpadDevice ? (
          <Container
            style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "7px" }}
          >
            <Typography
              component="div"
              style={{
                backgroundColor: "#ffffffe6",
                borderRadius: "15px",
                height: "93vh",
              }}
            >
              <Container style={{ marginTop: "10px", height: "5%" }}>
                <span
                  style={{
                    fontSize: "1.5em",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Worklist{" "}
                  <Refresh
                    onClick={() => setForce((old) => old + 1)}
                    style={{ fontSize: 20 }}
                  />
                </span>
              </Container>
              <Container
                style={{ padding: "25px", borderBottom: "2px solid lightgray" }}
              >
                <div className="summaryzz">
                  <div className="titles">
                    <div style={{ marginRight: "auto" }}>
                      <Button
                        style={{ textTransform: "none" }}
                        disabled={!filterData}
                        onClick={() => {
                          setFilterData(null);
                          localStorage.removeItem("Status");
                        }}
                        className="clearBTN"
                      >
                        Clear filter
                      </Button>
                    </div>
                  </div>
                  <div className="lB">
                    <div
                      className="dataBox"
                      style={{
                        backgroundColor: "rgb(255, 105, 97)",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        style={{
                          color: "#fff",
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                        }}
                        className="BTNControl"
                        disabled={
                          Filter?.filter((res) => res.status == "New").length ==
                          0
                        }
                        onClick={() => {
                          setFilterData("New");
                        }}
                      >
                        New :{" "}
                        {Filter?.filter((res) => res.status == "New").length}
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(253, 253, 150)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Pending")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Pending");
                        }}
                      >
                        On Process :{" "}
                        {
                          Filter?.filter((res) => res.status == "Pending")
                            .length
                        }
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(119, 221, 144)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          color: "#fff",
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Accept")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Accept");
                        }}
                      >
                        Close :{" "}
                        {Filter?.filter((res) => res.status == "Accept").length}
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(204, 204, 204)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Decline")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Decline");
                        }}
                      >
                        Decline :{" "}
                        {
                          Filter?.filter((res) => res.status == "Decline")
                            .length
                        }
                      </Button>
                    </div>
                  </div>
                </div>
                <Box style={{ margin: "auto 0" }} color="primary.main">
                  <Search_Panel data={Filter} {...searchProps} />
                </Box>
              </Container>
              <div style={{ padding: "10px" }}>
                {user.role == "Support" || user.role == "Buyer" ? (
                  <div className="flex-container ">
                    <div style={{ marginRight: "auto" }}>
                      <TextField
                        style={{
                          marginRight: "auto",
                          justifyContent: "flex-end",
                        }}
                        variant="standard"
                        value={searchText}
                        onChange={(event) => requestSearch(event.target.value)}
                        placeholder="Search…"
                        InputProps={{
                          startAdornment: <Search fontSize="small" />,
                          endAdornment: (
                            <IconButton
                              title="Clear"
                              aria-label="Clear"
                              size="small"
                              style={{
                                visibility:
                                  searchText != "" ? "visible" : "hidden",
                              }}
                              onClick={() => requestSearch("")}
                            >
                              <Clear fontSize="small" />
                            </IconButton>
                          ),
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex-container ">
                    <div style={{ marginRight: "auto" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#6ab23a",
                          color: "whitesmoke",
                          whiteSpace: "nowrap",
                          textTransform: "none",
                        }}
                        size="small"
                        onClick={() => props.history.push("/create-work")}
                      >
                        Create
                      </Button>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <TextField
                        style={{
                          marginRight: "auto",
                          justifyContent: "flex-end",
                        }}
                        variant="standard"
                        value={searchText}
                        onChange={(event) => requestSearch(event.target.value)}
                        placeholder="Search…"
                        InputProps={{
                          startAdornment: <Search fontSize="small" />,
                          endAdornment: (
                            <IconButton
                              title="Clear"
                              aria-label="Clear"
                              size="small"
                              style={{
                                visibility:
                                  searchText != "" ? "visible" : "hidden",
                              }}
                              onClick={() => requestSearch("")}
                            >
                              <Clear fontSize="small" />
                            </IconButton>
                          ),
                        }}
                      />
                    </div>
                  </div>
                )}
                <TableContainer
                  component={Paper}
                  style={{
                    borderRadius: "10px",
                    marginTop: "2%",
                    display: "block",
                  }}
                >
                  <Table className="ayLmao">
                    <TableHead
                      className="heheXd"
                      style={{
                        height: "50px",
                        position: "sticky",
                        textAlign: "center",
                      }}
                    >
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("id");
                            changeSortable("id");
                          }}
                        >
                          Create ID
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("type");
                            changeSortable("type");
                          }}
                        >
                          Type
                          {sortBy == "type" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "type" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("title");
                            changeSortable("title");
                          }}
                        >
                          Title
                          {sortBy == "title" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "title" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("status");
                            changeSortable("status");
                          }}
                        >
                          Status
                          {sortBy == "status" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "status" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("fullname");
                            changeSortable("fullname");
                          }}
                        >
                          Create Name
                          {sortBy == "fullname" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "fullname" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("createdAt");
                            changeSortable("createdAt");
                          }}
                        >
                          Create Date
                          {sortBy == "createdAt" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "createdAt" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("fullname2");
                            changeSortable("fullname2");
                          }}
                        >
                          Support Name
                          {sortBy == "fullname2" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "fullname2" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("updatedAt");
                            changeSortable("updatedAt");
                          }}
                        >
                          Update Date
                          {sortBy == "updatedAt" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "updatedAt" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    {!loading ? (
                      <TableBody style={{ textAlign: "center" }}>
                        {Filter.filter(filterStatusPin)
                          .sort(sortData())
                          .map((res, i) => (
                            <TableRow
                              style={
                                socketUpdate.find(
                                  (response) => response == res._id
                                )
                                  ? {
                                      backgroundColor: "#4eb04a",
                                      opacity: 0.75,
                                    }
                                  : { backgroundColor: "transparent" }
                              }
                              key={i}
                            >
                              <TableCell>
                                <Star
                                  style={{
                                    color: "#6ab23a",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => updatePin(res._id)}
                                />
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.id_created}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.type}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.file > 0 && (
                                  <AttachFile
                                    style={{
                                      fontSize: "14px",
                                      color: "black",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}{" "}
                                {res.title}
                              </TableCell>
                              <TableCell>
                                <div style={statusColorCheck(res.status)}>
                                  {statusChange(res.status)}{" "}
                                </div>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {deleteLastnameandEIEI(res.fullname)}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.createdAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.fullname2
                                  ? deleteLastnameandEIEI(res.fullname2)
                                  : "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.updatedAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell>
                                <Button
                                  type="submit"
                                  variant="contained"
                                  style={{
                                    border: "2px solid transparent",
                                    backgroundColor: "#6ab23a",
                                    borderRadius: "10px",
                                    color: "white",
                                    fontSize: "14px",
                                    textDecoration: "none",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() =>
                                    history.push(`detail-work/${res._id}`)
                                  }
                                >
                                  detail
                                </Button>{" "}
                                {(user.role == "Admin" ||
                                  user.role == "Retail" ||
                                  res.user_first == user.username) && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "red",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                    onClick={() => DeleteWork(res)}
                                  >
                                    delete
                                  </Button>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        {Filter.filter(filterStatusNoPin)
                          .sort(sortData())
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((res, i) => (
                            <TableRow
                              style={
                                socketUpdate.find(
                                  (response) => response == res._id
                                )
                                  ? {
                                      backgroundColor: "#4eb04a",
                                      opacity: 0.75,
                                    }
                                  : { backgroundColor: "transparent" }
                              }
                              key={i}
                            >
                              <TableCell>
                                <Star
                                  style={{ color: "black", cursor: "pointer" }}
                                  onClick={() => updatePin(res._id)}
                                />
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.id_created}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.type}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.file > 0 && (
                                  <AttachFile
                                    style={{
                                      fontSize: "14px",
                                      color: "black",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}{" "}
                                {res.title}
                              </TableCell>
                              <TableCell>
                                <div style={statusColorCheck(res.status)}>
                                  {statusChange(res.status)}{" "}
                                </div>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {deleteLastnameandEIEI(res.fullname)}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.createdAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.fullname2
                                  ? deleteLastnameandEIEI(res.fullname2)
                                  : "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.updatedAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell>
                                <Button
                                  type="submit"
                                  variant="contained"
                                  style={{
                                    border: "2px solid transparent",
                                    backgroundColor: "#6ab23a",
                                    borderRadius: "10px",
                                    color: "white",
                                    fontSize: "14px",
                                    textDecoration: "none",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() =>
                                    history.push(`detail-work/${res._id}`)
                                  }
                                >
                                  detail
                                </Button>
                                {res.user_first == user.username && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "red",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                    onClick={() => DeleteWork(res)}
                                  >
                                    delete
                                  </Button>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody style={{ margin: "auto" }}>
                        <TableRow>
                          <TableCell>
                            {" "}
                            <CircularProgress
                              size={30}
                              style={{ color: "#6ab23a" }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
                {Filter.length > 10 && (
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      {
                        label: "All",
                        value: Filter.filter(filterCondition).length,
                      },
                    ].filter(
                      (res) => res != Filter.filter(filterCondition).length
                    )}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    component="div"
                    count={Filter.filter(filterCondition).length}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                )}
              </div>
            </Typography>
          </Container>
        ) : (
          <div
            style={{
              paddingLeft: "50px",
              paddingRight: "50px",
              paddingTop: "7px",
            }}
          >
            <Typography
              component="div"
              style={{
                backgroundColor: "#ffffffe6",
                borderRadius: "15px",
                height: "93vh",
              }}
            >
              <Container style={{ marginTop: "10px", height: "5%" }}>
                <span
                  style={{
                    fontSize: "1.5em",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Worklist{" "}
                  <Refresh
                    onClick={() => setForce((old) => old + 1)}
                    style={{ fontSize: 20 }}
                  />
                </span>
              </Container>
              <Container
                style={{ padding: "25px", borderBottom: "2px solid lightgray" }}
              >
                <div className="summaryzz">
                  <div className="titles">
                    <div style={{ marginRight: "auto" }}>
                      <Button
                        style={{ textTransform: "none" }}
                        disabled={!filterData}
                        onClick={() => {
                          setFilterData(null);
                          localStorage.removeItem("Status");
                        }}
                        className="clearBTN"
                      >
                        Clear filter
                      </Button>
                    </div>
                  </div>
                  <div className="lB">
                    <div
                      className="dataBox"
                      style={{
                        backgroundColor: "rgb(255, 105, 97)",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        style={{
                          color: "#fff",
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                          border: filterData == "New" ? "2px solid" : "none",
                        }}
                        className="BTNControl"
                        disabled={
                          Filter?.filter((res) => res.status == "New").length ==
                          0
                        }
                        onClick={() => {
                          setFilterData("New");
                        }}
                      >
                        New :{" "}
                        {Filter?.filter((res) => res.status == "New").length}
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(253, 253, 150)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                          border:
                            filterData == "Pending" ? "2px solid" : "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Pending")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Pending");
                        }}
                      >
                        On Process :{" "}
                        {
                          Filter?.filter((res) => res.status == "Pending")
                            .length
                        }
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(119, 221, 144)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          color: "#fff",
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                          border: filterData == "Accept" ? "2px solid" : "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Accept")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Accept");
                        }}
                      >
                        Close :{" "}
                        {Filter?.filter((res) => res.status == "Accept").length}
                      </Button>
                    </div>
                    <div
                      className="dataBox"
                      style={{ backgroundColor: "rgb(204, 204, 204)" }}
                    >
                      <Button
                        className="BTNControl"
                        style={{
                          fontSize: "120%",
                          fontWeight: "bold",
                          width: "100%",
                          height: "100%",
                          borderRadius: "15px",
                          textTransform: "none",
                          border:
                            filterData == "Decline" ? "2px solid" : "none",
                        }}
                        disabled={
                          Filter?.filter((res) => res.status == "Decline")
                            .length == 0
                        }
                        onClick={() => {
                          setFilterData("Decline");
                        }}
                      >
                        Decline :{" "}
                        {
                          Filter?.filter((res) => res.status == "Decline")
                            .length
                        }
                      </Button>
                    </div>
                  </div>
                </div>
                <Box style={{ margin: "auto 0" }} color="primary.main">
                  <Search_Panel data={Filter} {...searchProps} />
                </Box>
              </Container>
              <div style={{ padding: "10px" }}>
                <div className="flex-container ">
                  {user?.add_work && (
                    <div style={{ marginRight: "auto" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#6ab23a",
                          color: "whitesmoke",
                          whiteSpace: "nowrap",
                          textTransform: "none",
                        }}
                        size="small"
                        onClick={() => props.history.push("/create-work")}
                      >
                        Create
                      </Button>
                    </div>
                  )}
                  <div style={{ marginLeft: "auto" }}>
                    <TextField
                      style={{
                        marginRight: "auto",
                        justifyContent: "flex-end",
                      }}
                      variant="standard"
                      value={searchText}
                      onChange={(event) => requestSearch(event.target.value)}
                      placeholder="Search…"
                      InputProps={{
                        startAdornment: <Search fontSize="small" />,
                        endAdornment: (
                          <IconButton
                            title="Clear"
                            aria-label="Clear"
                            size="small"
                            style={{
                              visibility:
                                searchText != "" ? "visible" : "hidden",
                            }}
                            onClick={() => requestSearch("")}
                          >
                            <Clear fontSize="small" />
                          </IconButton>
                        ),
                      }}
                    />
                  </div>
                </div>
                <TableContainer
                  component={Paper}
                  style={{
                    borderRadius: "10px",
                    marginTop: "2%",
                    display: data.length == 0 ? "none" : "block",
                  }}
                >
                  <Table className="ayLmao">
                    <TableHead
                      className="heheXd"
                      style={{
                        height: "50px",
                        position: "sticky",
                        textAlign: "center",
                      }}
                    >
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("id");
                            changeSortable("id");
                          }}
                        >
                          Create ID
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("type");
                            changeSortable("type");
                          }}
                        >
                          Type
                          {sortBy == "type" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "type" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("title");
                            changeSortable("title");
                          }}
                        >
                          Title
                          {sortBy == "title" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "title" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("status");
                            changeSortable("status");
                          }}
                        >
                          Status
                          {sortBy == "status" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "status" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("fullname");
                            changeSortable("fullname");
                          }}
                        >
                          Create Name
                          {sortBy == "fullname" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "fullname" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("createdAt");
                            changeSortable("createdAt");
                          }}
                        >
                          Create Date
                          {sortBy == "createdAt" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "createdAt" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("fullname2");
                            changeSortable("fullname2");
                          }}
                        >
                          Support Name
                          {sortBy == "fullname2" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "fullname2" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setSortBy("updatedAt");
                            changeSortable("updatedAt");
                          }}
                        >
                          Update Date
                          {sortBy == "updatedAt" && sortOrder == "desc" ? (
                            <ArrowUpward style={{ fontSize: "14px" }} />
                          ) : (
                            sortBy == "updatedAt" &&
                            sortOrder == "asc" && (
                              <ArrowDownward style={{ fontSize: "14px" }} />
                            )
                          )}
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    {!loading ? (
                      <TableBody style={{ textAlign: "center" }}>
                        {Filter.filter(filterStatusPin)
                          .sort(sortData())
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((res, i) => (
                            <TableRow
                              style={
                                socketUpdate.find(
                                  (response) => response == res._id
                                )
                                  ? {
                                      backgroundColor: "#4eb04a",
                                      opacity: 0.75,
                                    }
                                  : { backgroundColor: "transparent" }
                              }
                              key={i}
                            >
                              <TableCell>
                                <Star
                                  style={{
                                    color: "#6ab23a",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => updatePin(res._id)}
                                />
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.id_created}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.type}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.file > 0 && (
                                  <AttachFile
                                    style={{
                                      fontSize: "14px",
                                      color: "black",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}{" "}
                                {res.title}
                              </TableCell>
                              <TableCell>
                                <div style={statusColorCheck(res.status)}>
                                  {statusChange(res.status)}{" "}
                                </div>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {deleteLastnameandEIEI(res.fullname)}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.createdAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.fullname2
                                  ? deleteLastnameandEIEI(res.fullname2)
                                  : "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.updatedAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell>
                                <Link to={`detail-work/${res._id}`}>
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "#6ab23a",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    detail
                                  </Button>
                                </Link>{" "}
                                {(user.role == "Admin" ||
                                  user.role == "Retail" ||
                                  res.user_first == user.username) && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "red",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                    onClick={() => DeleteWork(res)}
                                  >
                                    delete
                                  </Button>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        {Filter.filter(filterStatusNoPin)
                          .sort(sortData())
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((res, i) => (
                            <TableRow
                              style={
                                socketUpdate.find(
                                  (response) => response == res._id
                                )
                                  ? {
                                      backgroundColor: "#4eb04a",
                                      opacity: 0.75,
                                    }
                                  : { backgroundColor: "transparent" }
                              }
                              key={i}
                            >
                              <TableCell>
                                <Star
                                  style={{ color: "black", cursor: "pointer" }}
                                  onClick={() => updatePin(res._id)}
                                />
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.id_created}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.type}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.file > 0 && (
                                  <AttachFile
                                    style={{
                                      fontSize: "14px",
                                      color: "black",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}{" "}
                                {res.title}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                <div style={statusColorCheck(res.status)}>
                                  {statusChange(res.status)}{" "}
                                </div>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {deleteLastnameandEIEI(res.fullname)}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.createdAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {res.fullname2
                                  ? deleteLastnameandEIEI(res.fullname2)
                                  : "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: socketUpdate.find(
                                    (response) => response == res._id
                                  )
                                    ? "white"
                                    : "black",
                                }}
                              >
                                {moment(res.updatedAt)
                                  .utcOffset("+0700")
                                  .format("DD MMM YYYY HH:mm:ss")}
                              </TableCell>
                              <TableCell>
                                <Link to={`detail-work/${res._id}`}>
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "#6ab23a",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    detail
                                  </Button>
                                </Link>{" "}
                                {(user.role == "Admin" ||
                                  user.role == "Retail" ||
                                  res.user_first == user.username) && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      border: "2px solid transparent",
                                      backgroundColor: "red",
                                      borderRadius: "10px",
                                      color: "white",
                                      fontSize: "14px",
                                      textDecoration: "none",
                                      textTransform: "capitalize",
                                    }}
                                    onClick={() => DeleteWork(res)}
                                  >
                                    delete
                                  </Button>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody style={{ margin: "auto" }}>
                        <TableRow>
                          <TableCell>
                            {" "}
                            <CircularProgress
                              size={30}
                              style={{ color: "#6ab23a" }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
                {Filter.length > 10 && (
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      {
                        label: "All",
                        value: Filter.filter(filterCondition).length,
                      },
                    ].filter(
                      (res) => res != Filter.filter(filterCondition).length
                    )}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    component="div"
                    count={Filter.filter(filterCondition).length}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                )}
              </div>
            </Typography>
          </div>
        )}
      </>
    )
  );
};

export default Work;
